import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Input } from 'next/components/ui';
import { start, selectSpoofing } from 'next/entities/spoofing';
import { selectUser, Shape as UserShape } from 'next/entities/user';
import { SpoofControlWrapper } from './styled';

export const SpoofControl = ({ onSpoof, spoofing, user }) => {
  const [value, setValue] = useState('');

  const { isAdmin } = user ?? {};

  if (!isAdmin || spoofing) {
    return null;
  }

  const handleChange = event => {
    const { value: text } = event.target;

    if (text === '' || /^[\d\b]+$/.test(text)) {
      setValue(text);
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
    onSpoof(value);
  };

  return (
    <SpoofControlWrapper onSubmit={handleSubmit}>
      <Input
        type="text"
        placeholder="Account ID"
        value={value}
        onChange={handleChange}
      />
      <Button kind="primary" onClick={handleSubmit}>
        Spoof
      </Button>
    </SpoofControlWrapper>
  );
};

SpoofControl.propTypes = {
  onSpoof: PropTypes.func,
  spoofing: PropTypes.bool,
  user: UserShape,
};

const mapStateToProps = state => ({
  spoofing: selectSpoofing(state),
  user: selectUser(state),
});

const mapDispatchToProps = {
  onSpoof: start,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpoofControl);
